module.exports = __webpack_public_path__ + "img/img60_3.2f7acb90.png";